import { getProxiedStoragePath } from './proxied-storage-path'

/** Real curated array members only. No fabricated filename or semantic guess. */
export function alternateCardImage(lead: string, images: readonly string[] = []): string | null {
  const normalizedLead = getProxiedStoragePath(lead).split(/[?#]/)[0]
  // A separately corrected lead must not fall back into an unproven older gallery.
  if (!images.some(image => typeof image === 'string' && getProxiedStoragePath(image.trim()).split(/[?#]/)[0] === normalizedLead)) return null
  for (const image of images) {
    if (typeof image !== 'string' || !image.trim()) continue
    const normalized = getProxiedStoragePath(image.trim())
    if (normalized.split(/[?#]/)[0] !== normalizedLead) return normalized
  }
  return null
}
